import React, { ReactNode } from "react";
import { Divider, Toolbar, Typography, Skeleton } from "@mui/material";
import { When, Unless } from "react-if";
import clsx from "clsx";

interface IPanelProps {
  title: String | ReactNode;
  children: ReactNode;
  classname?: string;
  isLoading?: boolean;
}

const PanelLoading = ({
  title,
  children,
  isLoading,
  classname,
}: IPanelProps) => {
  return (
    <>
      <div className="flex h-full w-full flex-col rounded-2xl bg-white shadow-lg">
        <When condition={isLoading}>
          <div className={clsx(classname, "h-96 pt-0")}>
            <Skeleton
              width="100%"
              height="100%"
              className="rounded-2xl"
              variant="rectangular"
            />
          </div>
        </When>
        <Unless condition={isLoading}>
          <div className="mt-2">
            <Toolbar variant="dense">
              <Typography variant="h6" className="m-0 w-full">
                {title}
              </Typography>
            </Toolbar>
            <Divider />
            <div className="flex flex-grow flex-col overflow-hidden px-6 py-6 md:overflow-y-auto">
              {children}
            </div>
          </div>
        </Unless>
      </div>
    </>
  );
};

export default PanelLoading;
